/**
 * barcodeModelTypes - Types, interfaces and constants for BarcodeModelSelector
 */
import React from 'react';
import { QrCode, Barcode as BarcodeIcon } from 'lucide-react';
import { Product } from '../../services/productService';

export type BarcodeModel = 'A' | 'B' | 'C' | 'D';

export interface BarcodeModelInfo {
  id: BarcodeModel;
  name: string;
  description: string;
  readings: number;
  format: string;
  icon: React.ReactNode;
}

export const BARCODE_MODELS: BarcodeModelInfo[] = [
  {
    id: 'A',
    name: 'Modelo A - Duas Leituras',
    description: '1ª: GTIN (01)XXXXX / 2ª: (17)YYMMDD(10)LOTE',
    readings: 2,
    format: 'Code 128',
    icon: <BarcodeIcon className="w-5 h-5" />,
  },
  {
    id: 'B',
    name: 'Modelo B - GS1-128',
    description: 'Leitura única: (01)GTIN(17)YYMMDD(10)LOTE',
    readings: 1,
    format: 'GS1-128',
    icon: <BarcodeIcon className="w-5 h-5" />,
  },
  {
    id: 'C',
    name: 'Modelo C - DataMatrix',
    description: 'Leitura única: (01)GTIN(17)YYMMDD(10)LOTE',
    readings: 1,
    format: 'DataMatrix',
    icon: <QrCode className="w-5 h-5" />,
  },
  {
    id: 'D',
    name: 'Modelo D - Apenas GTIN',
    description: 'EAN-13/GTIN-14 - Lote/Validade manual',
    readings: 1,
    format: 'EAN-13',
    icon: <BarcodeIcon className="w-5 h-5" />,
  },
];

export interface GeneratedBarcode {
  model: BarcodeModel;
  product: Product;
  gtin: string;
  lote?: string;
  validade?: string;
  codigoCompleto: string;
  codigoGtin?: string;
  codigoLoteValidade?: string;
}
